const state = {
  routeName: localStorage.getItem("route"),
};

const getters = {
  getRoute(state) {
    return state.routeName;
  },
};

const mutations = {
  SET_ROUTE(state, route) {
    state.routeName = route;
  },
};

const actions = {
  setRoute({ commit }, route) {
    localStorage.setItem("route", route);
    commit("SET_ROUTE", route);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
